import { countryCityConstants } from "../constants/countryCityConstants";
import { countryCityService } from "../../services/API/countryCityService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";
export const countryCityActions = {
  getAllStatesData,
  getAllCitiesData,
  getAllCountryData,
  getStateData,
  getStateDataPhyLoc,
  get_city_ByState,
  get_country_data,
  getCities
};
function getStateData(countryNameParams) {
  return dispatch => {
    countryCityService.get_state(countryNameParams).then(
      states => {
        dispatch(success(states));
      },
      error => {
        dispatch(failure(error.toString()));
        alert(error.toString());
      }
    );
  };

  function request(states) {
    return { type: countryCityConstants.FETCH_STATE_REQUEST, states };
  }
  function success(states) {
    return { type: countryCityConstants.FETCH_STATE_SUCCESS, states };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_STATE_FAILURE, error };
  }
}

function getAllStatesData(countryNameParams) {
  return dispatch => {
    countryCityService.get_states(countryNameParams).then(
      states => {
        dispatch(success(states));
      },
      error => {
        dispatch(failure(error.toString()));
        alert(error.toString());
      }
    );
  };

  function request(states) {
    return { type: countryCityConstants.FETCH_STATE_REQUEST, states };
  }
  function success(states) {
    return { type: countryCityConstants.FETCH_STATE_SUCCESS, states };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_STATE_FAILURE, error };
  }
}

function getStateDataPhyLoc(countryNameParams) {
  return dispatch => {
    countryCityService.get_state(countryNameParams).then(
      loc_states => {
        dispatch(success(loc_states));
      },

      error => {
        dispatch(failure(error.toString()));
        alert(error.toString());
      }
    );
  };

  function request(loc_states) {
    return { type: countryCityConstants.FETCH_STATELOC_REQUEST, loc_states };
  }
  function success(loc_states) {
    return { type: countryCityConstants.FETCH_STATELOC_SUCCESS, loc_states };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_STATELOC_FAILURE, error };
  }
}

function get_city_ByState(stateAbbr) {
  return dispatch => {
    countryCityService.get_citydetails_ByState(stateAbbr).then(
      cityDetailsByState => {
        dispatch(success(cityDetailsByState));
      },

      error => {
        dispatch(failure(error.toString()));
        alert(error.toString());
      }
    );
  };

  function request(cityDetailsByState) {
    return {
      type: countryCityConstants.GET_CITY_DETAILS_BYSTATE_REQUEST,
      cityDetailsByState
    };
  }
  function success(cityDetailsByState) {
    return {
      type: countryCityConstants.GET_CITY_DETAILS_BYSTATE_SUCCESS,
      cityDetailsByState
    };
  }
  function failure(error) {
    return {
      type: countryCityConstants.GET_CITY_DETAILS_BYSTATE_FAILURE_,
      error
    };
  }
}

function getAllCitiesData(stateAbbr) {
  return dispatch => {
    countryCityService.get_cities(stateAbbr).then(
      cityDetailsByState => {
        dispatch(success(cityDetailsByState));
      },

      error => {
        dispatch(failure(error.toString()));
        alert(error.toString());
      }
    );
  };

  function request(cityDetailsByState) {
    return {
      type: countryCityConstants.GET_CITY_DETAILS_BYSTATE_REQUEST,
      cityDetailsByState
    };
  }
  function success(cityDetailsByState) {
    return {
      type: countryCityConstants.GET_CITY_DETAILS_BYSTATE_SUCCESS,
      cityDetailsByState
    };
  }
  function failure(error) {
    return {
      type: countryCityConstants.GET_CITY_DETAILS_BYSTATE_FAILURE_,
      error
    };
  }
}

export function getAllCountryData() {
  return dispatch => {
    countryCityService.get_countries().then(
      countries => {
        dispatch(success(countries));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(countries) {
    return { type: countryCityConstants.FETCH_COUNTRIES_REQUEST, countries };
  }
  function success(countries) {
    return { type: countryCityConstants.FETCH_COUNTRIES_SUCCESS, countries };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_COUNTRIES_FAILURE, error };
  }
}

function get_country_data() {
  return dispatch => {
    countryCityService.get_country_data().then(
      countries => {
        dispatch(success(countries));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(countries) {
    return { type: countryCityConstants.FETCH_COUNTRIES_REQUEST, countries };
  }
  function success(countries) {
    return { type: countryCityConstants.FETCH_COUNTRIES_SUCCESS, countries };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_COUNTRIES_FAILURE, error };
  }
}

export const add_city = postData => {
  return dispatch => {
    countryCityService.add_city(postData).then(
      city => {
        dispatch(success(city));
        history.push("/cityAndCountry");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(city) {
    return { type: countryCityConstants.ADD_CITY_REQUEST, city };
  }
  function success(city) {
    return { type: countryCityConstants.ADD_CITY_SUCCESS, city };
  }
  function failure(error) {
    return { type: countryCityConstants.ADD_CITY_FAILURE, error };
  }
};

export const get_state = countryNameParams => {
  return dispatch => {
    countryCityService.get_state(countryNameParams).then(
      states => {
        dispatch(success(states));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(states) {
    return { type: countryCityConstants.FETCH_STATE_REQUEST, states };
  }
  function success(states) {
    return { type: countryCityConstants.FETCH_STATE_SUCCESS, states };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_STATE_FAILURE, error };
  }
};

export const get_all_city = formData => {
  return dispatch => {
    countryCityService.get_all_city(formData).then(
      cities => {
        dispatch(success(cities));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(cities) {
    return { type: countryCityConstants.FETCH_CITIES_REQUEST, cities };
  }
  function success(cities) {
    return { type: countryCityConstants.FETCH_CITIES_SUCCESS, cities };
  }
  function failure(error) {
    return { type: countryCityConstants.FETCH_CITIES_FAILURE, error };
  }
};

export const delete_city = cityIdASParams => {
  return dispatch => {
    countryCityService.delete_city(cityIdASParams).then(
      city => {
        dispatch(success(city));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(city) {
    return { type: countryCityConstants.DELETE_CITY_REQUEST, city };
  }
  function success(city) {
    return { type: countryCityConstants.DELETE_CITY_SUCCESS, city };
  }
  function failure(error) {
    return { type: countryCityConstants.DELETE_CITY_FAILURE, error };
  }
};

export const get_city_details = cityIdParams => {
  return dispatch => {
    countryCityService.get_city_details(cityIdParams).then(
      cityDetails => {
        dispatch(success(cityDetails));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(cityDetails) {
    return { type: countryCityConstants.GET_CITY_DETAILS_REQUEST, cityDetails };
  }
  function success(cityDetails) {
    return { type: countryCityConstants.GET_CITY_DETAILS_SUCCESS, cityDetails };
  }
  function failure(error) {
    return { type: countryCityConstants.GET_CITY_DETAILS_FAILURE, error };
  }
};

export const update_city = postData => {
  return dispatch => {
    countryCityService.update_city(postData).then(
      updatedCity => {
        dispatch(success(updatedCity));
        history.push("/cityAndCountry");
      },
      error => {
        alert(error.toString());
      }
    );
  };

  function request(updatedCity) {
    return { type: countryCityConstants.UPDATE_CITY_REQUEST, updatedCity };
  }
  function success(updatedCity) {
    return { type: countryCityConstants.UPDATE_CITY_SUCCESS, updatedCity };
  }
  function failure(error) {
    return { type: countryCityConstants.UPDATE_CITY_FAILURE, error };
  }
};

export const add_city_status = formData => {
  return dispatch => {
    countryCityService.add_city_status(formData).then(
      propsData => {
        dispatch(success(propsData));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(propsData) {
    return { type: countryCityConstants.ADD_CITY_STATUS_REQUEST, propsData };
  }
  function success(propsData) {
    return { type: countryCityConstants.ADD_CITY_STATUS_SUCCESS, propsData };
  }
  function failure(error) {
    return { type: countryCityConstants.ADD_CITY_STATUS_FAILURE, error };
  }
};

export const getCities = () => {
  return dispatch => {
    countryCityService.getCities().then(
      cities => {
        dispatch(success(cities));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(cities) {
    return { type: countryCityConstants.GET_CITIES_REQUEST, cities };
  }
  function success(cities) {
    return { type: countryCityConstants.GET_CITIES_SUCCESS, cities };
  }
  function failure(error) {
    return { type: countryCityConstants.GET_CITIES_FAILURE, error };
  }
};

export const getCountry = () => {
    return dispatch => {
      countryCityService.get_country_data().then(
        countries => {
          dispatch(success(countries));

        },

        error => {
          dispatch(failure(error.toString()));
        }
      );
    };

    function request(countries) {
      return { type: countryCityConstants.FETCH_COUNTRIES_REQUEST, countries };
    }
    function success(countries) {
      return { type: countryCityConstants.FETCH_COUNTRIES_SUCCESS, countries };
    }
    function failure(countries) {
      return { type: countryCityConstants.FETCH_COUNTRIES_FAILURE, error };
    }
};

export const getCountryCity = (countryName) => {
    return dispatch => {
      countryCityService.getCountryCity(countryName).then(
        countries => {
          dispatch(success(countries));

        },

        error => {
          dispatch(failure(error.toString()));
        }
      );
    };

    function request(countries) {
      return { type: countryCityConstants.GET_COUNTRIESCITY_REQUEST, countries };
    }
    function success(countries) {
      return { type: countryCityConstants.GET_COUNTRIESCITY_SUCCESS, countries };
    }
    function failure(countries) {
      return { type: countryCityConstants.GET_COUNTRIESCITY_FAILURE, error };
    }
};

export const add_city_SoldOut = formData => {
  return dispatch => {
    countryCityService.add_city_SoldOut(formData).then(
      propsData => {
        dispatch(success(propsData));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(propsData) {
    return { type: countryCityConstants.ADD_CITY_SOLDOUT_REQUEST, propsData };
  }
  function success(propsData) {
    return { type: countryCityConstants.ADD_CITY_SOLDOUT_SUCCESS, propsData };
  }
  function failure(error) {
    return { type: countryCityConstants.ADD_CITY_SOLDOUT_FAILURE, error };
  }
};

export const add_FB_Link = formData => {
  return dispatch => {
    countryCityService.add_FB_Link(formData).then(
      propsData => {
        dispatch(success(propsData));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(propsData) {
    return { type: countryCityConstants.ADD_FB_LINK_REQUEST, propsData };
  }
  function success(propsData) {
    return { type: countryCityConstants.ADD_FB_LINK_SUCCESS, propsData };
  }
  function failure(error) {
    return { type: countryCityConstants.ADD_FB_LINK_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/countryCityActions.js